import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendOtpLamf, verifyOtpLamf } from "../../../store/actions";

import { Paper } from "@material-ui/core";

import ShareCard from "../nps/ShareCard";

const LAMF = () => {
  const dispatch = useDispatch();

  const { mobile } = useSelector((state) => state.authReducer);

  const [verifyId, setVerifyId] = useState("");

  const { referralLink } = useSelector((state) => state.lamfReducer);

  const displayOTP = !referralLink;

  const sendOtp = async () => {
    const response = await dispatch(sendOtpLamf({ mobileNo: `+91${mobile}` }));
    if (!!response.data && !!response.data.data) {
      setVerifyId(response.data.data.verify_id);
    }
  };

  useEffect(() => {
    if (!!mobile && displayOTP) {
      sendOtp();
    }
  }, [mobile, dispatch]); //eslint-disable-line

  return (
    <>
      {!!displayOTP ? (
        <Otp
          mobileNumber={`+91${mobile}`}
          dispatch={dispatch}
          verifyId={verifyId}
          resendOtp={sendOtp}
        />
      ) : (
        <div className="d-flex flex-row justify-content-center">
          <ShareCard url={referralLink} title="Referral Link" />
        </div>
      )}
    </>
  );
};

const Otp = ({ mobileNumber, dispatch, verifyId, resendOtp }) => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [otpError, setOtpError] = useState(false);

  const maskedMobileNumber = mobileNumber.replace(/\d(?=\d{4})/g, "x");

  const handleChange = (index) => (e) => {
    const value = e.target.value;
    if (value.length <= 1) {
      setOtp([...otp.slice(0, index), value, ...otp.slice(index + 1)]);
      if (index !== 3 && !!value) {
        document.getElementById(`textInput${index + 1}`).focus();
      } else {
        document.getElementById(`textInput${index}`).blur();
      }
    }
  };

  const handleKeyDown = (index) => (e) => {
    if (e.keyCode === 8) {
      setOtp([...otp.slice(0, index), "", ...otp.slice(index + 1)]);
      if (index !== 0) {
        document.getElementById(`textInput${index - 1}`).focus();
      }
    }
  };

  const handleSubmit = async () => {
    const otpString = otp.join("");
    const response = await dispatch(
      verifyOtpLamf({
        mobileNo: mobileNumber,
        otp: otpString,
        verify_id: verifyId,
        platform_id: 2,
      })
    );
    if (!response.status) {
      setOtp(["", "", "", ""]);
      setOtpError(true);
      document.getElementById("textInput0").focus();
    }
  };

  return (
    <>
      <div className="otp-container">
        <Paper className="otp-paper">
          <div className="otp-header">OTP Verification</div>
          <div className="text-center">
            <span>
              A One Time Password has been successfully sent to{" "}
              {maskedMobileNumber}
            </span>
          </div>
          <div className="otp forgot-otp">
            {Array(4)
              .fill(0)
              .map((item, index) => (
                <OtpInput
                  value={otp[index]}
                  key={index}
                  onChange={handleChange(index)}
                  onKeyDown={handleKeyDown(index)}
                  id={`textInput${index}`}
                />
              ))}
          </div>
          {!otp.join("").length && otpError && (
            <>
              <div className="text-danger text-center">
                Please enter a valid OTP
              </div>
            </>
          )}
          <div className="d-flex justify-content-center mt-3">
            <button
              className="otp-submit-button"
              onClick={handleSubmit}
              disabled={otp.join("").length !== 4}
              id="otp-submit-button"
            >
              Validate
            </button>
          </div>
          {!otp.join("").length && otpError && (
            <div
              className="d-flex justify-content-center mt-2 mouse-pointer"
              onClick={() => resendOtp()}
            >
              <span className="lamf-resend-otp">Resend OTP</span>
            </div>
          )}
        </Paper>
      </div>
    </>
  );
};

const OtpInput = (props) => {
  return (
    <div>
      <input
        className="otp_input number-input border-dark text-center"
        type="number"
        {...props}
      />
    </div>
  );
};

export default LAMF;
